module.exports = __webpack_public_path__ + "static/media/bigdata_analysis_p.febfe7ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/bigdata_analysis_p.jpg
// module id = 369
// module chunks = 0